export const LADE_AUSWAHLWERTE_LOHN = "ladeAuswahlwerteLohn";
